declare const jQuery: JQueryStatic;
const $ = jQuery;

export function initMultiContentSliders(): void {
    $('.multi-content-slider').each(function () {
        const $wrap = $(this);
        const $slider = $wrap.find('.finite-slider');
        const $sliderItems = $slider.find('.slider-item');
        const $prev = $wrap.find('.chevron-prev');
        const $next = $wrap.find('.chevron-next');
        const updateChevronText = (index: number) => {
            if (index > 0) {
                const prevText: string = $sliderItems.eq(index - 1).attr('data-slider-item-label') || '';
                $prev.find('.chevron-text').text(prevText);
            }
            if (index < $sliderItems.length - 1) {
                const nextText: string = $sliderItems.eq(index + 1).attr('data-slider-item-label') || '';
                $next.find('.chevron-text').text(nextText);
            }
        };
        $slider.on('slide', (event, data) => {
            updateChevronText(data.itemIndex);
            data.prevAllowed ? $prev.addClass('show') : $prev.removeClass('show');
            data.nextAllowed ? $next.addClass('show') : $next.removeClass('show');
        });
        $prev.on('click', () => {
            $slider.trigger('slide-to-prev-item');
        });
        $next.on('click', () => {
            $slider.trigger('slide-to-next-item');
        });
        updateChevronText(0);
        $next.addClass('show');
    });
}
